import Index from '@/pages/index'
import Login from '@/pages/login'
import Layout from '@/pages/layout'
import FooterLayout from '@/pages/FooterLayout'
import Notfound from '@/pages/404'
import Download from '@/pages/download'
import Privacy from '@/pages/privacy'
import Agreement from '@/pages/agreement'
// 打印历史
import Record from '@/pages/record/index'
// 模板打印
// import Template from '@/pages/template/index'
// 我的
import My from '@/pages/my/index'
// 修改密码
import Password from '@/pages/my/password'
// 激活打印机记录
import printerRecord from '@/pages/my/printerRecord'
// 核销标签记录
import tagRecord from '@/pages/my/tagRecord'
// 常见问题
import problem from '@/pages/my/problem'
// 更新公告
import updateNotice from '@/pages/my/updateNotice'
// 公告详情
import noticeDetail from '@/pages/my/noticeDetail'
// 统计图表
import Statistic from '@/pages/statistic/index'
// 打印页面
// import Print from '@/pages/print/index'
// 模板切换打印页面/历史打印页面
import Switch from '@/pages/print/switch'
// 蓝牙设备（打印机）
import Device from '@/pages/device/index'


export default [
 {  
    path: '/',
    component: Layout,
    children: [
      {
        path: '/',
        component: FooterLayout,
        children:[
          {
            name: '标签管家',
            path: '/index',
            component: Index,
            meta: {
              opacity: 1
            }
          },
          {
            name: '补打',
            path: '/print-again',
            component: Record,
            meta: {
              opacity: 0.8
            }
          },
          {
            name: '我的模板',
            path: '/template',
            component: Switch,
            meta: {
              opacity: 0.8
            }
          },
          {
            name: '我的页面',
            path: '/my',
            component: My,
            meta: {
              opacity: 0.3
            }
          },
          {
            name: '激活打印机记录',
            path: '/printerRecord',
            component: printerRecord,
            meta: {
              opacity: 0.3
            }
          },
          {
            name: '核销标签记录',
            path: '/tagRecord',
            component: tagRecord,
            meta: {
              opacity: 0.3
            }
          },
          {
            name: '常见问题',
            path: '/problem',
            component: problem,
            meta: {
              opacity: 0.3
            }
          },
          {
            name: '更新公告',
            path: '/updateNotice',
            component: updateNotice,
            meta: {
              opacity: 0.3
            }
          },
          // 更新公告详情
          {
            name: '更新公告',
            path: '/noticeDetail',
            component: noticeDetail,
            meta: {
              opacity: 0.3
            }
          },
        ]
      },
      {
        name: '打印历史',
        path: '/record',
        component: Record,
        meta: {
          opacity: 0.8
        }
      },
      {
        name: '打印统计',
        path: '/statistic',
        component: Statistic,
        meta: {
          opacity: 0.8
        }
      },
      {
        name: '标签打印',
        path: '/print/:id',
        component: Switch,
        meta: {
          opacity: 0.8
        }
      },
      {
        name: '我的页面',
        path: '/password',
        component: Password,
        meta: {
          opacity: 0.3
        }
      },
      {
        name: '连接打印机',
        path: '/device',
        component: Device,
        meta: {
          opacity: 0.8
        }
      }
    ]
  },
  {
    name: '登录',
    path: '/login',
    component: Login
  },
  {
    name: '下载',
    path: '/download',
    component: Download
  },
  {
    name: '隐私政策',
    path: '/privacy',
    component: Privacy
  },
  {
    name: '服务协议',
    path: '/agreement',
    component: Agreement
  },
  {
    path: '*',
    component: Notfound
  }
]